export default __webpack_public_path__ + "static/media/Search.4510a1b9.svg";